import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  {
    page: PageMeta.Dashboard.ecommerce,
    title: 'Dashboard',
    icon: { icon: PageMeta.Dashboard.ecommerce.icon },
    to: PageMeta.Dashboard.ecommerce.name,
    badgeClass: 'bg-primary',
  },
]
